<template>
  <div class="">
    <el-form :inline="true" :model="list" status-icon :rules="rules" ref="list" label-width="100px" class="demo-ruleForm my">
      <!-- <div class="n1 clear"> -->
      <!--  <el-form-item label="申请部门：" prop="pk_dept" class="tinp">
          <el-input v-model="list.pk_dept" placeholder="请输入申请部门" prefix-icon="el-icon-edit" clearable @change="onParamChange"></el-input>
        </el-form-item> -->
      <el-form-item label="调入门店：" prop="minstorename" class="tinp">
        <el-input v-model="list.minstorename" placeholder="请选择调入门店" prefix-icon="el-icon-search" clearable v-on:click.native="openselectmodel(-1)" @change="onParamChange"></el-input>
      </el-form-item>
      <el-form-item label="申请业务员：" prop="cinpsnidname" class="tinp">
        <el-input v-model="list.cinpsnidname" placeholder="请输入申请业务员" prefix-icon="el-icon-edit" clearable @change="onParamChange"></el-input>
      </el-form-item>
      <!-- </div> -->
      <!-- <div class="n1 clear"> -->
      <el-form-item label="调出门店：" prop="moutstorename" class="tinp" v-show="false">
        <el-input v-model="list.moutstorename" placeholder="请选择调出门店" prefix-icon="el-icon-search" clearable v-on:click.native="openselectmodel(-2)" @change="onParamChange"></el-input>
      </el-form-item>
      <!-- </div> -->
      <!-- <div class="n1 clear"> -->
      <el-form-item label="备注：" class="tinp beizhuinp" style="width: 478px;margin-left: 0px !important">
        <el-input v-model="list.memo" placeholder="请输入内容" prefix-icon="el-icon-edit" clearable @change="onParamChange"></el-input>
      </el-form-item>
      <!-- </div> -->
      <div class=" clear">
        <el-form-item class="fr mingxibut">
          <el-button type="primary" class="" @click="submitForm('list')"  v-loading.fullscreen.lock="fullscreenLoading">确认提交</el-button>
        </el-form-item>
        <el-form-item class="fr mingxibut">
          <el-button type="primary" class="" @click="addList()">添加明细</el-button>
        </el-form-item>
      </div>
      <div class="line"></div>
      <div class="tablebox">
        <div style="overflow-y: auto;height:222px">
          <table style="width:100%">
            <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
              <th style="" v-for="head in tableHeads">{{ head.label }}</th>
              <th style="width:105px">删除</th>
            </tr>
            <tr v-for="(item,index) in list.productList" :key="">
              <td style="border: 1px solid #56B8AA; height: 38px;width:200px">
                <el-input style="width: 200px" class="tabinp" v-model="item.coutrepertoryname" clearable @change="onParamChange"></el-input>
              </td>
              <td style="border: 1px solid #56B8AA; height: 38px;width:200px">
                <el-input v-model="item.hinpositionname" placeholder="选择货位" suffix-icon="el-icon-search" v-on:click.native="openselectmodel(index)"></el-input>
              </td>
              <td style="border: 1px solid #56B8AA; height: 38px;width:240px">
                <el-input style="width: 240px" class="tabinp" placeholder="选择商品" suffix-icon="el-icon-search" v-model="item.productName" clearable @change="onParamChange" v-on:click.native="selectProduct(index)"></el-input>
              </td>
              <td style="border: 1px solid #56B8AA; height: 38px;width:240px">
                <span style="width:220px">{{item.wlspec}}</span>
              </td>
              <td style="border: 1px solid #56B8AA; height: 38px;width:240px">
                <span style="width:220px">{{item.wltype}}</span>
              </td>
              <td style="border: 1px solid #56B8AA; height: 38px;width:100px">
                <span style="width:220px">{{item.cunitname}}</span>
              </td>
              <!--  <td style="border: 1px solid #56B8AA; height: 38px;width:100px">
                   <span style="width:220px">{{item.corigcurrencyid}}</span>
                 </td> -->
              <td style="border: 1px solid #56B8AA; height: 38px;width:100px">
                <el-input class="tabinp" v-model="item.nnum" clearable @change="onParamChange"></el-input>
              </td>
              <td style="border: 1px solid #56B8AA; height: 38px">
                <el-button size="mini" type="danger"  :disabled="index==0" @click="handleDelete(index)">删除</el-button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </el-form>
    <!-- model start -->
    <div class="model selectmodel" v-show="modelShow">
      <div class="content">
        <div class="title">
          <span class="fl">选择门店</span>
          <span class="fr" @click="closemodel(1)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="selectinput">
          <el-form :inline="true" style="padding:10px">
            <el-form-item class="" style="width:100%;margin: 0 !important" v-if="selectid=='1'">
              <el-select @change="selectchange" filterable value-key="storecode" v-model="store.storename" clearable placeholder="请选择调入门店" style="width:100%;" auto-complete="off">
                <el-option v-for="item in storeList" :key="item.storecode" :label="item.storename" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="" style="width:100%;margin: 0 !important" v-if="selectid=='2'">
              <el-select @change="selectchange" filterable value-key="storecode" v-model="store.storename" clearable placeholder="请选择调出门店" style="width:100%;" auto-complete="off">
                <el-option v-for="item in storeList" :key="item.storecode" :label="item.storename" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="" style="width:100%;margin: 0 !important" v-if="selectid=='3'">
              <el-select @change="selectchange" filterable value-key="positioncode" v-model="position.positionname" clearable placeholder="请选择调出货位" style="width:100%;" auto-complete="off">
                <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- model start -->
    <!-- model start -->
    <div class="model" v-show="modelShow2">
      <div class="content">
        <div class="title">
          <span class="fl">请选择商品</span>
          <span class="fr" @click="closemodel(2)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="procontent clearfix" style="padding: 0 20px">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="商品名称：" class="tinp">
              <el-input v-model="serchpro.productName" suffix-icon="el-icon-search" clearable @change="selectProduct"></el-input>
            </el-form-item>
            <el-button type="primary" class="" size="small" icon="el-icon-search" @click="selectProduct">搜索</el-button>
          </el-form>
          <div class="productList" style="overflow-y: auto;overflow-x:hidden;width:100%;height: auto;max-height:332px">
            <table style="width:100%">
              <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
                <th style="border: 1px solid #56B8AA;">选择</th>
                <th style="" v-for="head in proTitle">{{ head.label }}</th>
              </tr>
              <tr v-for="(item,index) in productList2" :id="index" :key="index">
                <td class="fir" style="color: #fff;border: 1px solid #56B8AA;">
                  <div class="list-item-check">
                    <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose(index)">
                                        <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                    </span>
                  </div>
                </td>
                <td v-for="head in proTitle" style="border: 1px solid #56B8AA; height: 38px" @click="choose(index)">
                  {{item[head.key]}}
                </td>
              </tr>
            </table>
          </div>
          <el-button type="primary" class="fr" size="medium" style="margin-top: 16px" @click="checkpro">确定</el-button>
        </div>
      </div>
    </div>
    <!-- model start -->
    <!-- model end -->
    <div class="" v-show="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
      <MessageModel types="提示信息" :msg="msg" :flag="modelFlag2" :butmsg="butmsg2" :butflag = "butflag2" @modelmsg="returnMsg2"></MessageModel> 
  </div>
</template>
<script> 
// import { setCookie, getCookie, delCookie } from '../../../static/js/cookie.js'
export default {
  name: '',
  data() {
    var validateDept = (rule, value, callback) => { //部门规则
      if (value === '') {
        callback(new Error('申请部门不能为空'));
      } else {
        callback();
      }
    };
    var validateOrg = (rule, value, callback) => { //调入门店规则
      if (value === '') {
        callback(new Error('申请调入门店不能为空'));
      } else {
        callback();
      }
    };
    var validateOutdeptid = (rule, value, callback) => { //调出门店规则
      if (value === '') {
        callback(new Error('申请调出门店不能为空'));
      } else {
        callback();
      }
    };
    var validatePsndoc = (rule, value, callback) => { //业务员规则
      if (value === '') {
        callback(new Error('申请业务员不能为空'));
      } else {
        callback();
      }
    };

    return {
      flag:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      InterfacePath: '',
      user: {}, 
      proTitle: [{
          label: '商品编码',
          key: 'materialcode'
        },
        {
          label: '商品名称',
          key: 'materialname'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },

        {
          label: '单价',
          key: 'nprice'
        },
        {
          label: '单位',
          key: 'measdocname'
        }
      ],
      selectid: '1',
      fullscreenLoading: false,
      modelShow: false,
      modelShow2: false,
      list: {
        // pk_dept: '',//申请部门
        minstorecode: '', //调入门店
        minstorename: '', //调入门店
        moutstorecode: '', //调出门店
        moutstorename: '', //调出门店
        cinpsnidcode: '', //申请业务员
        cinpsnidname: '', //申请业务员
        memo: '', //备注
        productList: [{ //产品列表
          coutrepertorycode: '',
          coutrepertoryname: '',
          corigcurrencyid: '', //本币含税单价
          productName: '', //商品
          productCode: '', //商品
          wlspec: '', //规格
          wltype: '', //型号
          cunitname: '', //单位
          vbatchcode: '', //批次号
          ntaxratecode: '', //税率编码
          ntaxratename: '', //税率值
          nnum: '' //申请数量
        }]
      },
      productName: '',
      serchpro: {
        storecode: '',
        productName: '',
      },
      productList2: [],
      tableListindex: 0,
      position: {
        positioncode: '', //货位编码
        positionname: '' //货位名称
      },
      store: {
        storecode: '', //门店编码
        storename: '' //门店名称
      },
      positionList: [],
      storeList: [],
      index: '',
      index2: '',
      shanindex: '',
      tableHeads: [{
          label: '调出仓库',
          key: 'coutrepertoryname'
        },
        {
          label: '调出货位',
          key: 'houtpositionname'
        },
        {
          label: '商品名称',
          key: 'productName'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '单位',
          key: 'cunitname'
        },
        // {
        //     label: '批次号',
        //     key: 'vbatchcode'
        // },
        // {
        //     label: '单价',
        //     key: 'corigcurrencyid'
        // },
        {
          label: '申请数量',
          key: 'nnum'
        }
      ],
      rules: { //规则明细
        pk_dept: [
          { required: true, trigger: 'blur', validator: validateDept } //
        ],
        minstorename: [
          { required: true, trigger: 'blur', validator: validateOrg } //
        ],
        moutstorename: [
          { required: true, trigger: 'blur', validator: validateOutdeptid } //
        ],
        pk_psndoc: [
          { required: true, trigger: 'blur', validator: validatePsndoc } //
        ],
      }
    }
  },
  destroyed() {
    sessionStorage.removeItem("destroyed");
    sessionStorage.removeItem("productList2");
    sessionStorage.removeItem("diaolist");
    //console.log("清除session");
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
            // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                //console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag2 = true;
                      this.methodName = 'message';
                      this.msg = '门店请购单信息删除失败';
                      this.butflag2 =false;
                      this.butmsg2='知道了'; 
                    }
                }, (err) => {
                    this.modelFlag2 = true;
                    this.methodName = 'message';
                    this.msg = '获取接口失败';
                    this.butflag2 =false;
                    this.butmsg2='知道了';  
                })
            }else if(this.methodName =='shanhang'){ 
              if (this.list.productList.length > 1) {
                this.list.productList.splice(this.shanindex, 1);
              }
              sessionStorage.setItem("diaolist", JSON.stringify(this.list));
            }else if(this.methodName =='tizeng'){ 
                  this.fullscreenLoading = true;
                  var ApplyBill = {
                    applybill: JSON.stringify(this.list),
                  };
                  this.$http.post(this.InterfacePath + '/insertApplyBill', ApplyBill, { emulateJSON:true,_timeout:600 }).then((res) => {
                    // this.$http.post('ktnapi/insertApplyBill',ApplyBill,{emulateJSON:true}).then((res)=>{
                    if (res.data.status == '0') {
                      this.fullscreenLoading = false;
                      this.$message({
                        showClose: true,
                        message: '申请成功！',
                        type: 'succcess'
                      });
                      this.list = {
                        minstorecode: this.user.storecode, //调入门店
                        minstorename: this.user.storename, //调入门店
                        moutstorecode: '', //调出门店
                        moutstorename: '', //调出门店
                        cinpsnidcode: this.user.user_code, //申请业务员
                        cinpsnidname: this.user.user_name, //申请业务员
                        memo: '', //备注
                        productList: [{ //产品列表
                          coutrepertorycode: this.user.storehouse_code,
                          coutrepertoryname: this.user.storehouse_name,
                          corigcurrencyid: '', //本币含税单据
                          productName: '', //商品
                          wlspec: '', //规格
                          wltype: '', //型号
                          cunitname: '', //单位
                          vbatchcode: '', //批次号
                          nnum: '' //申请数量
                        }]
                      };
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                            this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else {
                      this.fullscreenLoading = false;
                      this.modelFlag2 = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag2 =false;
                      this.butmsg2='知道了'; 
                    }

                  }, (err) => {
                    this.fullscreenLoading = false;
                    this.modelFlag2 = true;
                    this.methodName = 'message';
                    this.msg = res.data.message;
                    this.butflag2 =false;
                    this.butmsg2='知道了'; 
                  });
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    returnMsg2(flag) {

      this.modelFlag2 = false;
      
       if (flag) {
       // console.log("---进来了！！！----" + this.methodName);
        if (this.methodName == 'message') {

        } 
      }
    }, 
    choose(index) {
     // console.log("-=-=-=-=-=-=-打印下标" + index);
      this.productList2[index].checked = this.productList2[index].checked == '1' ? '0' : '1';
      for (var i = 0; i < this.productList2.length; i++) {
        if (i != index) {
          this.productList2[i].checked = '0'
          document.getElementById(i).style.backgroundColor = "#fff"
        }
      }
      if (this.productList2[index].checked == '1') {

        document.getElementById(index).style.backgroundColor = "#FFEFB7"
      } else {

        document.getElementById(index).style.backgroundColor = "#fff"
      }
      this.index2 = index;
    },
    checkpro() {
      // console.log("_=-=-=-=-=" + this.index + "-=-=-=-=-=-" + this.index2);
      if (this.productList2[this.index2].checked != '1') {
        this.modelFlag2 = true;
        this.methodName = 'message';
        this.msg = '请至少选择一件商品';
        this.butflag2 =false;
        this.butmsg2='知道了'; 
      } else {
        this.list.productList[this.index].productName = this.productList2[this.index2].materialname;
        this.list.productList[this.index].productCode = this.productList2[this.index2].materialcode;
        this.list.productList[this.index].wlspec = this.productList2[this.index2].wlspec;
        this.list.productList[this.index].wltype = this.productList2[this.index2].wltype;
        this.list.productList[this.index].cunitcode = this.productList2[this.index2].measdoccode;
        this.list.productList[this.index].cunitname = this.productList2[this.index2].measdocname;
        this.list.productList[this.index].ntaxratecode = this.productList2[this.index2].ntaxratecode;
        this.list.productList[this.index].ntaxratename = this.productList2[this.index2].ntaxratename;
        this.list.productList[this.index].corigcurrencyid = this.productList2[this.index2].nprice;
        this.list.productList[this.index].ntaxratecode = this.productList2[this.index2].taxratecode;
        this.list.productList[this.index].ntaxratename = this.productList2[this.index2].taxratename;
        this.modelShow2 = false;
        // console.log("-=-==-=-=-=-=-打印商品信息" + JSON.stringify(this.list.productList[this.index]));
      }
    },
    init() {
      this.user = JSON.parse(window.localStorage.getItem("userInfo"));
      // console.log("打印用户" + JSON.stringify(this.user));
      //sessionStorage.removeItem("diaolist"); console.log("1");
      var bigdata = JSON.parse(sessionStorage.getItem("diaolist"));
      if (bigdata != null) {
        this.list = bigdata
        // console.log("非空");
      } else {
        // console.log("空");
        // this.list.pk_dept = user.pk_dept;
        this.list.moutstorename = this.user.storecode;
        this.list.moutstorename = this.user.storename;
        this.list.cinpsnidcode = this.user.user_code;
        this.list.cinpsnidname = this.user.user_name;
        this.list.productList[0].coutrepertorycode = this.user.storehouse_code;
        this.list.productList[0].coutrepertoryname = this.user.storehouse_name;
        // console.log("sesson数据：" + sessionStorage.getItem("diaolist"));
      }
    },
    getposition() {
      //获取数据接口
      var reqParams = {
        storecode: this.user.storecode
      }
      this.$http.post(this.InterfacePath + '/selectStorespositioninfo', reqParams, { emulateJSON: true,_timeout:600 }).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          // var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
         // console.log("打印货位" + JSON.stringify(this.positionList));
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.positionList = [];
        }
        // console.log("获取的JSON数据"+JSON.stringify(res.result));       
      }, (err) => {
        console.log(err);
      });
    },
    selectProduct(num) {
     // console.log("-=-=-=-=-==-" + JSON.stringify(this.serchpro));
      this.index = num == null ? this.index : num;
      this.modelShow2 = true;
      var prod = JSON.parse(sessionStorage.getItem("productList2"));

      if (prod != null && this.serchpro.productName == this.productName) {
        this.productList2 = prod;
      } else {
        this.serchpro.storecode = this.user.storecode;

        this.$http.post(this.InterfacePath + "/selectAllSpdirectory", this.serchpro, { emulateJSON: true,_timeout:600 }).then((result) => {
          // this.$http.post("ktnapi/selectAllSpdirectory",this.serchpro,{emulateJSON:true}).then((result) => {
          var res = result.data;
          if (res.status == '0') {
            this.productList2 = res.resultList;
            this.productName = this.serchpro.productName;
            if (this.serchpro.productName != '' || this.serchpro.productName != null) {

              sessionStorage.setItem("productList2", JSON.stringify(this.productList2));
            }
            //console.log("_+_+初始化打印商品信息_+_+_" + JSON.stringify(this.productList2));
          } else if (res.data.status == '-1') {
            this.productList2=[];
            //console.log("-----暂无数据！！！");
          } else if(res.data.status == '9'){
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.modelFlag2 = true;
            this.methodName = 'message';
            this.msg = res.message;
            this.butflag2 =false;
            this.butmsg2='知道了';
            // this.$alert(res.message, '失败信息', {
            //   confirmButtonText: '确定'
            // });
          }
        }, (err) => {
          this.modelFlag2 = true;
          this.methodName = 'message';
          this.msg = '调用查询商品目录接口失败';
          this.butflag2 =false;
          this.butmsg2='知道了';
          // this.$alert('调用查询商品目录接口失败', '失败信息', {
          //   confirmButtonText: '确定'
          // });
          console.log(err);
        });
      };
    },
    getstore() {
      //获取数据接口

      // this.$http.get('api/store').then((res) => {
      this.$http.post(this.InterfacePath + '/selectStore', { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          var stores = res.data.resultList;
          this.storeList = [];
          for (var i = stores.length - 1; i > -1; i--) {
            this.storeList.push({ storename: stores[i].storename, storecode: stores[i].storecode });
          }
          //console.log("打印货位" + JSON.stringify(this.storeList));
        } else if (res.data.status == '-1') {
          this.storeList = [];
         // console.log("-----暂无数据！！！");
        } else if(res.data.status == '9'){
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.modelFlag2 = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag2 =false;
          this.butmsg2='知道了';
          // this.$alert(res.data.message, '失败信息', {
          //   confirmButtonText: '确定'
          // });

        }

      }, (err) => {
        this.modelFlag2 = true;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag2 =false;
        this.butmsg2='知道了';
        // this.$alert('连接获取门店信息接口失败', '失败信息', {
        //   confirmButtonText: '确定'
        // });
        console.log(err);
      });
    },
    selectchange(value) {
     // console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
      // console.log("下拉变化事件1"+JSON.stringify(this.store)+"下标：");
      // console.log("下拉变化事件2"+value.positioncode);
      if (this.selectid == '1') {
        this.list.minstorename = value.storecode;
        this.list.minstorename = value.storename;
        this.modelShow = false;
        this.store = {
          storecode: '',
          storename: ''
        };
      } else if (this.selectid == '2') {
        this.list.moutstorecode = value.storecode;
        this.list.moutstorename = value.storename;
        this.modelShow = false;
        this.store = {
          storecode: '',
          storename: ''
        };
      } else {
        this.list.productList[this.tableListindex].hinpositioncode = value.positioncode;
        this.list.productList[this.tableListindex].hinpositionname = value.positionname;
        this.list.productList.forEach((item) => {
         // console.log("打印：" + JSON.stringify(item));
        });
        sessionStorage.setItem("diaolist", JSON.stringify(this.list));
        this.modelShow = false;
        this.position = {
          positioncode: '',
          positionname: ''
        };
      }

    },
    openselectmodel(index) {
    //  console.log("model内打印：" + index);
      if (index == -1) {
        this.modelShow = true;
        this.selectid = "1"
        this.getstore();
      } else if (index == -2) {
        this.modelShow = true;
        this.selectid = "2"
        this.getstore();
      } else {
        this.tableListindex = index;
        this.selectid = "3"
        this.modelShow = true;
        this.getposition();
      }
    },
    closemodel(num) {
      if (num == '1') {

        this.modelShow = false;
      } else {

        this.modelShow2 = false;
        this.index = '';
        this.index2 = '';
      }
    },

    addList() { //添加明细 
      var lis = {
        coutrepertorycode: this.user.storehouse_code, //调入仓库
        coutrepertoryname: this.user.storehouse_name, //调入仓库 
        corigcurrencyid: '', //本币含税单价
        productName: '', //商品
        wlspec: '', //规格
        wltype: '', //型号
        cunitname: '', //单位
        vbatchcode: '', //批次号
        ntaxratecode: '', //税率编码
        ntaxratename: '', //税率值
        nnum: '' //申请数量
      }
      this.list.productList.push(lis);
      sessionStorage.setItem("diaolist", JSON.stringify(this.list));
    },
    //搜索框变化事件
    onParamChange() {
      sessionStorage.setItem("diaolist", JSON.stringify(this.list));

    },
    handleDelete(index) { //删除数据
      this.shanindex = index;
      this.methodName = 'shanhang';
      this.modelFlag = true;
      this.butflag = true;
      this.butmsg='确认';
      this.msg = '此操作将删除该行，是否继续？'; 
    },
    submitForm(formName) { //提交表单
      var reqParams = this.list;
      //console.log("测试list是否为空" + JSON.stringify(this.list));
     // console.log("测试调出门店是否为空" + this.list.moutstorename);
      this.$refs[formName].validate((valid) => {
        if (valid) { //符合规则
          var flag = true;
          this.list.productList.forEach((item) => { //遍历数据判断数据是否符非空 
            if (item.cinrepertorycode === '' || item.productName === '' || item.nnum === '') {
              this.$message({
                showClose: true,
                message: '请将明细表填写完整！',
                type: 'error'
              });
              //console.log("index:" + JSON.stringify(item));
              flag = false;
              return;
            }
          });
          if (!flag) {
            return;
          } else {
            this.methodName = 'tizeng';
            this.modelFlag = true;
            this.butflag = true;
            this.butmsg='确认';
            this.msg = '此操作将进行保存验证，是否继续？'; 
          }
        } else {
          this.$message({
            showClose: true,
            message: '申请失败！',
            type: 'error'
          });
         // console.log('error submit!!');
          return false;
        }

      });
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stock/zengdiao.vue